/**
 * Consolida filas de ventas en un total: `v_ventas_diarias` viene agrupada por cuenta de dinero, y
 * aquí suman la pantalla Hoy, el resultado del mes, el `/hoy` del bot y el digest de la sonda.
 * Sirve a cualquier grano: un día por cuenta, o los días de un mes.
 */
interface FilaVentas {
  total: number | string;
  num_ventas: number | string;
  num_anuladas?: number | string;
  total_anulado?: number | string;
}

export interface TotalesVentas {
  total: number;
  numVentas: number;
  numAnuladas: number;
  totalAnulado: number;
}

/** PostgREST devuelve `numeric` como string, así que todo pasa por `Number` antes de sumar. */
export function sumarVentas(filas: readonly FilaVentas[]): TotalesVentas {
  return filas.reduce<TotalesVentas>(
    (acumulado, fila) => ({
      total: acumulado.total + Number(fila.total ?? 0),
      numVentas: acumulado.numVentas + Number(fila.num_ventas ?? 0),
      numAnuladas: acumulado.numAnuladas + Number(fila.num_anuladas ?? 0),
      totalAnulado: acumulado.totalAnulado + Number(fila.total_anulado ?? 0),
    }),
    { total: 0, numVentas: 0, numAnuladas: 0, totalAnulado: 0 }
  );
}

/** La venta promedio del período. Sin ventas es 0, no una división por cero. */
export function ventaPromedio({ total, numVentas }: Pick<TotalesVentas, 'total' | 'numVentas'>): number {
  return numVentas > 0 ? Math.round(total / numVentas) : 0;
}
